import {
  Alert,
  AlertTitle,
  LinearProgress,
  Stack,
  Typography,
} from "@mui/material";

interface AutoFlowLoadingBarProps {
  ranByUser: string;
  value: number;
}

export const AutoFlowLoadingBar = ({
  ranByUser,
  value,
}: AutoFlowLoadingBarProps) => {
  const clamped = Math.min(100, Math.max(0, value));

  if (clamped >= 100) {
    return (
      <Alert severity="success" sx={{ mt: 1 }}>
        <AlertTitle>AutoFlow completed successfully</AlertTitle>
        View Automation Record Audit for results
      </Alert>
    );
  }

  return (
    <Stack sx={{ width: "100%" }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="subtitle1" color="text.secondary">
          Running AutoFlow
        </Typography>
        <Typography color="text.secondary" fontWeight="bold">
          {`${Math.floor(clamped)}%`}
        </Typography>
      </Stack>
      <LinearProgress
        variant="determinate"
        value={clamped}
        sx={{
          height: 15,
          borderRadius: 5,
          backgroundColor: (theme) =>
            theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
        }}
      />
      <Typography variant="caption" color="text.secondary">
        Started by: {ranByUser}
      </Typography>
    </Stack>
  );
};
